import { ParseQuery } from './parse-query';
import { Role, User } from '@shared/data';

export class RoleQuery extends ParseQuery<Role> {
  constructor(roleId?: string) {
    super(Role);

    if (roleId) {
      this.equalTo('objectId', roleId);
    }
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/queries/role-query.ts